module.exports = __webpack_public_path__ + "static/media/banner_2.70c8079a.jpg";